import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { utcToZonedTime } from 'date-fns-tz';
import { useEffect, useState } from 'react';

const CustomTimePicker = ({ name, value, format, handleChange, disabled, renderInput }) => {
    const [localTimeZone, setLocalTimeZone] = useState(Intl.DateTimeFormat().resolvedOptions().timeZone);

    useEffect(() => {
        setLocalTimeZone(Intl.DateTimeFormat().resolvedOptions().timeZone);
    }, []);

    const localTime = value ? utcToZonedTime(value, localTimeZone) : null;
    console.log('localTime', localTime)

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <TimePicker
                format={format}
                name={name}
                value={localTime}
                onChange={handleChange}
                disabled={disabled}
                renderInput={renderInput}
            />
        </LocalizationProvider>
    )
}

export default CustomTimePicker